import { authClient, API } from '../index'

export const getAllManufacturers = () => {
    return authClient().get(`${API}/manufacturer/?getDisabled=true`)
}

// Get manufacturer by id
export const getManufacturerById = (id) => {
    return authClient().get(`${API}/manufacturer/${id}`)
}

// Create manufacturer
export const postManufacturer = async (manufacturer) => {
    return authClient().post(`${API}/manufacturer/`, manufacturer)
}

// Update text
export const updateManufacturer = (id, manufacturer) => {
    return authClient().put(`${API}/manufacturer/${id}`, manufacturer)
}

// Change status manufacturer
export const changeStatusManufacturer = async (id, active) => {
    return authClient().put(`${API}/manufacturer/change-status/${id}`, { active });
};


// Delete manufacturer
export const deleteManufacturer = (id) => {
    return authClient().delete(`${API}/manufacturer/${id}`)
}
